<template>
  <div class="A10_xgsm aboutchild">
    <div class="aboutchildbox">
      <div class="title">
        <img src="@/common/images/about/A10_xgsm/titleL.png" alt="" />
        <span>相关声明</span>
        <img src="@/common/images/about/A10_xgsm/titleR.png" alt="" />
      </div>
      <div class="zlList">
        <ul>
          <li
            class="lidome"
            v-for="(item, index) in list1"
            :key="index"
            @click="toDetail(item.str)"
          >
            <span class="titlespan" :title="item.title">{{ item.title }}</span>
            <span class="time">{{ item.time }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "A10_xgsm",
  data() {
    return {
      list1: [
        {
          title: "风险揭示书",
          time: "2025-03-17",
          str: "fxjss",
        },
        {
          title: "免责声明",
          time: "2025-03-17",
          str: "mzsm",
        },
        {
          title: "公司声明",
          time: "2025-03-17",
          str: "gssm",
        },
        {
          title: "隐私保护政策",
          time: "2025-03-17",
          str: "ysbhzc",
        },
      ],
    };
  },
  mounted() {
    this.getlist();
  },
  methods: {
    getlist: function () {
      //console.log("lawColumn");
    },
    toDetail: function (str) {
      this.$router.push({
        name: "B10_xgsm",
        query: {
          str: str,
        },
      });
    },
  },
};
</script>
<style scoped>
.aboutchild {
  width: 100%;
  overflow: hidden;
  opacity: 1;
  background: #fff;
}
.aboutchildbox {
  width: 1077px;
  opacity: 1;
  margin-left: 280px;
  min-height: 940px;
  overflow: hidden;
}
.title {
  width: 100%;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.title span {
  display: block;
  height: 56px;
  font-size: 40px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 56px;
  color: #1d1d1d;
  opacity: 1;
  margin: 0 50px;
}

.zlList,
.zlpage {
  overflow: hidden;
  margin: 0 auto;
}
.zlpage {
  margin-top: 40px;
  margin-bottom: 60px;
}
.zlList ul {
  overflow: hidden;
}
.lidome {
  width: 1077px;
  height: 91px;
  border-bottom: 1px solid #d5d5d5;
  opacity: 1;
  display: flex;
  justify-content: space-between;
  padding-top: 26px;
  box-sizing: border-box;
  cursor: pointer;
}
.lidome:hover .titlespan {
  color: #e7413b;
}
.lidome:hover .time {
  color: #e7413b;
}
.lidome span {
  display: block;
}
.lidome .titlespan {
  width: 821px;
  height: 65px;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 65px;
  color: #333333;
  opacity: 1;
  text-align: left;
  /*  */
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.lidome .time {
  width: 160px;
  height: 65px;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 65px;
  color: #666666;
  opacity: 1;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/components/aboutS/A10_xgsm.vue